import {
  CaretDownOutlined,
  CloseOutlined,
  LeftOutlined,
  RightOutlined,
} from '@ant-design/icons';
import { Drawer } from 'antd';
import { Input } from 'components/input/input';
import { Date, XpayComponent } from 'core/domains';
import moment from 'jalali-moment';
import * as React from 'react';
import ReactModal from 'react-modal';
import { MONTHS } from 'utils/constants';
import useOnBlur from 'utils/scripts/useOnBlur';
import { isMobile } from 'react-device-detect';
import './calendar.scss';

interface Props extends XpayComponent {
  error?: string[];
  label: string;
  name: string;
  placeholder?: string;
  onChange?: (value: string) => void;
}

const min_year = parseInt(moment(moment.now()).format('jYYYY')) - 100;
const max_year = parseInt(moment(moment.now()).format('jYYYY'));

const { useState, useRef } = React;

export const Calendar: React.FC<Props> = (props) => {
  const [date, setDate] = useState<Date>();
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [stage, setStage] = useState<string>('YEAR');

  const [selectedMonth, setSelectedMonth] = useState<number>();
  // parseInt(moment(moment.now()).format('jMM')),
  const [selectedYear, setSelectedYear] = useState<number>();
  // parseInt(moment(moment.now()).format('jYYYY')),
  const [selectedDay, setSelectedDay] = useState<number>();

  // parseInt(moment(moment.now()).format('jDD')),

  const closeDrawer = () => {
    setIsOpen(false);
  };
  const ref = useRef<any>();

  useOnBlur(ref, () => {
    if (isOpen && selectedYear && selectedMonth && selectedDay)
      setIsOpen(false);
  });

  function renderMonths() {
    let list = [];
    for (let i = 0; i <= 11; i++) {
      let month = MONTHS[i];
      list.push(
        <li
          className={`${selectedMonth === i + 1 ? 'active' : ''}`}
          onClick={() => {
            setSelectedMonth(i + 1);
            setDate({ ...date, month: selectedMonth });
            setTimeout(() => setStage('DAY'), 200);
          }}
          key={`month-${i}`}
        >
          {month}
        </li>,
      );
    }
    return list;
  }

  function renderYears() {
    let list = [];
    for (let year = min_year; year <= max_year; year++) {
      list.push(
        <li
          className={`${selectedYear === year ? 'active' : ''}`}
          key={`year-${year}`}
          onClick={() => {
            setSelectedYear(year);
            setDate({ ...date, year: selectedYear });
            setTimeout(() => setStage('MONTH'), 200);
          }}
        >
          {year}
        </li>,
      );
    }
    return list;
  }

  function renderDays() {
    let monthDays = 31;

    let list = [];
    for (let day = 1; day <= monthDays; day++) {
      list.push(
        <li
          className={`${selectedDay === day ? 'active' : ''}`}
          key={`day-${day}`}
          onClick={() => {
            setSelectedDay(day);
            setDate({ ...date, day: selectedDay });
            setTimeout(() => setIsOpen(false), 200);
            setStage('YEAR');
          }}
        >
          {day}
        </li>,
      );
    }

    return list;
  }

  React.useEffect(() => {
    if (selectedMonth && selectedDay && selectedYear)
      setDate({ day: selectedDay, month: selectedMonth, year: selectedYear });
    props.onChange &&
      selectedMonth &&
      selectedDay &&
      selectedYear &&
      props?.onChange(
        `${`${selectedYear && selectedYear}/${selectedMonth && selectedMonth}/${
          selectedDay && selectedDay
        }`}`,
      );
  }, [selectedYear, selectedDay, selectedMonth]);

  return (
    <div ref={ref} className="xpay-calendar">
      <Input
        name={props.name}
        type="text"
        value={
          date?.month && date?.year && date?.day
            ? `${date?.year}/${date?.month}/${date?.day}`
            : ''
        }
        onChange={() => {}}
        disabled={true}
        maxLength={10}
        errors={props.error}
        placeholder={props.placeholder}
        onClick={() => setIsOpen(true)}
        adorments={{
          endAdornment: {
            adornmentIcon: (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="19"
                height="22"
                viewBox="0 0 19 22"
                fill="none"
              >
                <path
                  d="M2.26183 20.2699L2.71582 19.3789L2.26183 20.2699ZM1.33947 19.3474L0.448466 19.8014L1.33947 19.3474ZM17.7684 19.3474L16.8774 18.8934L17.7684 19.3474ZM16.8454 20.2699L16.3914 19.3789L16.8454 20.2699ZM16.8454 3.84121L17.2994 2.9502L16.8454 3.84121ZM17.7684 4.76382L16.8774 5.21781L17.7684 4.76382ZM2.26183 3.84121L2.71582 4.73222L2.26183 3.84121ZM1.33947 4.76382L2.23048 5.21781L1.33947 4.76382ZM13.776 16.2778V15.2778C13.2238 15.2778 12.776 15.7255 12.776 16.2778H13.776ZM13.7782 16.2778L14.7779 16.3011C14.7842 16.0319 14.6816 15.7716 14.4935 15.579C14.3053 15.3864 14.0474 15.2778 13.7782 15.2778V16.2778ZM13.7781 16.2799L13.7542 17.2796C14.0194 17.2859 14.2763 17.1866 14.4683 17.0035C14.6603 16.8204 14.7716 16.5685 14.7778 16.3032L13.7781 16.2799ZM13.776 16.2798H12.776C12.776 16.8228 13.2093 17.2666 13.7521 17.2796L13.776 16.2798ZM9.55382 16.2778V15.2778C9.00153 15.2778 8.55382 15.7255 8.55382 16.2778H9.55382ZM9.55593 16.2778L10.5557 16.3011C10.5619 16.0319 10.4594 15.7716 10.2712 15.579C10.0831 15.3864 9.8252 15.2778 9.55593 15.2778V16.2778ZM9.55588 16.2799L9.53196 17.2796C9.7972 17.2859 10.0541 17.1866 10.2461 17.0035C10.4381 16.8204 10.5494 16.5685 10.5556 16.3032L9.55588 16.2799ZM9.55382 16.2798H8.55382C8.55382 16.8228 8.98709 17.2666 9.5299 17.2796L9.55382 16.2798ZM5.3316 16.2778V15.2778C4.77931 15.2778 4.3316 15.7255 4.3316 16.2778H5.3316ZM5.33371 16.2778L6.33344 16.3011C6.33973 16.0319 6.23719 15.7716 6.04903 15.579C5.86086 15.3864 5.60297 15.2778 5.33371 15.2778V16.2778ZM5.33366 16.2799L5.30974 17.2796C5.57498 17.2859 5.83186 17.1866 6.02385 17.0035C6.21584 16.8204 6.32719 16.5685 6.33339 16.3032L5.33366 16.2799ZM5.3316 16.2798H4.3316C4.3316 16.8228 4.76487 17.2666 5.30768 17.2796L5.3316 16.2798ZM13.7781 12.0556H14.7781C14.7781 11.5033 14.3304 11.0556 13.7781 11.0556V12.0556ZM13.7781 12.0577L13.7542 13.0574C14.0235 13.0638 14.284 12.9614 14.4767 12.7732C14.6694 12.585 14.7781 12.327 14.7781 12.0577H13.7781ZM13.776 12.0576H12.776C12.776 12.6006 13.2093 13.0443 13.7521 13.0573L13.776 12.0576ZM13.776 12.0556V11.0556C13.2238 11.0556 12.776 11.5033 12.776 12.0556H13.776ZM9.55382 12.0556V11.0556C9.00153 11.0556 8.55382 11.5033 8.55382 12.0556H9.55382ZM9.55593 12.0556L10.5557 12.0789C10.5619 11.8097 10.4594 11.5494 10.2712 11.3568C10.0831 11.1641 9.8252 11.0556 9.55593 11.0556V12.0556ZM9.55588 12.0577L9.53196 13.0574C9.7972 13.0637 10.0541 12.9644 10.2461 12.7813C10.4381 12.5982 10.5494 12.3463 10.5556 12.081L9.55588 12.0577ZM9.55382 12.0576H8.55382C8.55382 12.6006 8.98709 13.0443 9.5299 13.0573L9.55382 12.0576ZM5.3316 12.0556V11.0556C4.77931 11.0556 4.3316 11.5033 4.3316 12.0556H5.3316ZM5.33371 12.0556L6.33344 12.0789C6.33973 11.8097 6.23719 11.5494 6.04903 11.3568C5.86086 11.1641 5.60297 11.0556 5.33371 11.0556V12.0556ZM5.33366 12.0577L5.30974 13.0574C5.57498 13.0637 5.83186 12.9644 6.02385 12.7813C6.21584 12.5982 6.32719 12.3463 6.33339 12.081L5.33366 12.0577ZM5.3316 12.0576H4.3316C4.3316 12.6006 4.76487 13.0443 5.30768 13.0573L5.3316 12.0576ZM1.10938 6.83333C0.55709 6.83333 0.109375 7.28105 0.109375 7.83333C0.109375 8.38562 0.55709 8.83333 1.10938 8.83333V6.83333ZM17.9983 8.83333C18.5505 8.83333 18.9983 8.38562 18.9983 7.83333C18.9983 7.28105 18.5505 6.83333 17.9983 6.83333V8.83333ZM14.776 1.5C14.776 0.947715 14.3283 0.5 13.776 0.5C13.2238 0.5 12.776 0.947715 12.776 1.5H14.776ZM12.776 3.61111C12.776 4.1634 13.2238 4.61111 13.776 4.61111C14.3283 4.61111 14.776 4.1634 14.776 3.61111H12.776ZM6.3316 1.5C6.3316 0.947715 5.88388 0.5 5.3316 0.5C4.77931 0.5 4.3316 0.947715 4.3316 1.5H6.3316ZM4.3316 3.61111C4.3316 4.1634 4.77931 4.61111 5.3316 4.61111C5.88388 4.61111 6.3316 4.1634 6.3316 3.61111H4.3316ZM4.48736 4.61111H14.6207V2.61111H4.48736V4.61111ZM16.9983 6.98884V17.1222H18.9983V6.98884H16.9983ZM14.6207 19.5H4.48736V21.5H14.6207V19.5ZM2.10938 17.1222V6.98884H0.109375V17.1222H2.10938ZM4.48736 19.5C3.87972 19.5 3.48398 19.4992 3.18199 19.4745C2.89162 19.4508 2.7771 19.4101 2.71582 19.3789L1.80784 21.1609C2.19814 21.3597 2.60523 21.4341 3.01914 21.4679C3.42144 21.5008 3.91267 21.5 4.48736 21.5V19.5ZM0.109375 17.1222C0.109375 17.6968 0.108597 18.188 0.141458 18.5902C0.175271 19.0041 0.24961 19.4111 0.448466 19.8014L2.23048 18.8934C2.19924 18.8321 2.15853 18.7176 2.13482 18.4274C2.11015 18.1255 2.10938 17.7298 2.10938 17.1222H0.109375ZM2.71582 19.3789C2.5069 19.2724 2.33708 19.1026 2.23048 18.8934L0.448466 19.8014C0.746661 20.3866 1.22229 20.8625 1.80784 21.1609L2.71582 19.3789ZM16.9983 17.1222C16.9983 17.7299 16.9975 18.1256 16.9729 18.4275C16.9493 18.7178 16.9086 18.8322 16.8774 18.8934L18.6594 19.8014C18.8583 19.411 18.9326 19.0039 18.9663 18.5901C18.9991 18.1879 18.9983 17.6967 18.9983 17.1222H16.9983ZM14.6207 21.5C15.1954 21.5 15.6864 21.5008 16.0885 21.4679C16.5024 21.4341 16.9092 21.3597 17.2994 21.1609L16.3914 19.3789C16.33 19.4101 16.2156 19.4508 15.9256 19.4745C15.6238 19.4992 15.2284 19.5 14.6207 19.5V21.5ZM16.8774 18.8934C16.7711 19.1019 16.601 19.2721 16.3914 19.3789L17.2994 21.1609C17.8842 20.8629 18.3609 20.3873 18.6594 19.8014L16.8774 18.8934ZM14.6207 4.61111C15.2284 4.61111 15.6239 4.61189 15.9256 4.63655C16.2156 4.66025 16.33 4.70094 16.3914 4.73222L17.2994 2.9502C16.9092 2.75138 16.5024 2.67702 16.0885 2.6432C15.6864 2.61033 15.1953 2.61111 14.6207 2.61111V4.61111ZM18.9983 6.98884C18.9983 6.41427 18.9991 5.92314 18.9663 5.52102C18.9326 5.10721 18.8583 4.7002 18.6594 4.30983L16.8774 5.21781C16.9086 5.27904 16.9493 5.39337 16.9729 5.68358C16.9975 5.98549 16.9983 6.38107 16.9983 6.98884H18.9983ZM16.3914 4.73222C16.6009 4.83895 16.7711 5.00915 16.8774 5.21781L18.6594 4.30983C18.3609 3.72403 17.8843 3.24827 17.2994 2.9502L16.3914 4.73222ZM4.48736 2.61111C3.91268 2.61111 3.42145 2.61033 3.01916 2.64319C2.60526 2.677 2.19816 2.75132 1.80784 2.9502L2.71582 4.73222C2.77709 4.701 2.89159 4.66027 3.18197 4.63655C3.48396 4.61189 3.8797 4.61111 4.48736 4.61111V2.61111ZM2.10938 6.98884C2.10938 6.38117 2.11015 5.98558 2.13482 5.68374C2.15852 5.39358 2.19923 5.27915 2.23048 5.21781L0.448466 4.30983C0.249622 4.70008 0.175275 5.107 0.141459 5.52086C0.108597 5.92305 0.109375 6.41417 0.109375 6.98884H2.10938ZM1.80784 2.9502C1.22219 3.24861 0.746607 3.7247 0.448466 4.30983L2.23048 5.21781C2.33714 5.00848 2.50701 4.83861 2.71582 4.73222L1.80784 2.9502ZM13.776 17.2778H13.7782V15.2778H13.776V17.2778ZM12.7784 16.2544L12.7784 16.2565L14.7778 16.3032L14.7779 16.3011L12.7784 16.2544ZM13.802 15.2802L13.8 15.2801L13.7521 17.2796L13.7542 17.2796L13.802 15.2802ZM14.776 16.2798V16.2778H12.776V16.2798H14.776ZM9.55382 17.2778H9.55593V15.2778H9.55382V17.2778ZM8.5562 16.2544L8.55615 16.2565L10.5556 16.3032L10.5557 16.3011L8.5562 16.2544ZM9.5798 15.2802L9.57774 15.2801L9.5299 17.2796L9.53196 17.2796L9.5798 15.2802ZM10.5538 16.2798V16.2778H8.55382V16.2798H10.5538ZM5.3316 17.2778H5.33371V15.2778H5.3316V17.2778ZM4.33398 16.2544L4.33393 16.2565L6.33339 16.3032L6.33344 16.3011L4.33398 16.2544ZM5.35758 15.2802L5.35552 15.2801L5.30768 17.2796L5.30974 17.2796L5.35758 15.2802ZM6.3316 16.2798V16.2778H4.3316V16.2798H6.3316ZM12.7781 12.0556V12.0577H14.7781V12.0556H12.7781ZM13.802 11.058L13.8 11.0579L13.7521 13.0573L13.7542 13.0574L13.802 11.058ZM14.776 12.0576V12.0556H12.776V12.0576H14.776ZM13.776 13.0556H13.7781V11.0556H13.776V13.0556ZM9.55382 13.0556H9.55593V11.0556H9.55382V13.0556ZM8.5562 12.0322L8.55615 12.0343L10.5556 12.081L10.5557 12.0789L8.5562 12.0322ZM9.5798 11.058L9.57774 11.0579L9.5299 13.0573L9.53196 13.0574L9.5798 11.058ZM10.5538 12.0576V12.0556H8.55382V12.0576H10.5538ZM5.3316 13.0556H5.33371V11.0556H5.3316V13.0556ZM4.33398 12.0322L4.33393 12.0343L6.33339 12.081L6.33344 12.0789L4.33398 12.0322ZM5.35758 11.058L5.35552 11.0579L5.30768 13.0573L5.30974 13.0574L5.35758 11.058ZM6.3316 12.0576V12.0556H4.3316V12.0576H6.3316ZM1.10938 8.83333H17.9983V6.83333H1.10938V8.83333ZM12.776 1.5V3.61111H14.776V1.5H12.776ZM4.3316 1.5V3.61111H6.3316V1.5H4.3316Z"
                  fill="#1552F0"
                />
              </svg>
            ),
          },
        }}
      />
      <Drawer
        onClose={closeDrawer}
        closable
        className="xpay-calendar-drawer"
        open={isMobile && isOpen === true ? true : false}
        placement="bottom"
        title={props.label}
      >
        <div className={`calendar`}>
          <div className="head">
            <div className="right-side">
              <div className="month" onClick={() => setStage('MONTH')}>
                {MONTHS[(selectedMonth && selectedMonth - 1) || 1]}
              </div>
              <div className="year" onClick={() => setStage('YEAR')}>
                {selectedYear}
              </div>
              <CaretDownOutlined
                onClick={() =>
                  stage === 'MONTH' ? setStage('YEAR') : setStage('MONTH')
                }
              />
            </div>
            <div className="left-side">
              <RightOutlined
                onClick={() => {
                  if (selectedMonth !== 1) {
                    setSelectedMonth(selectedMonth && selectedMonth - 1);
                  } else {
                    setSelectedMonth(12);
                  }
                }}
              />
              <LeftOutlined
                onClick={() => {
                  if (selectedMonth !== 12) {
                    setSelectedMonth(selectedMonth && selectedMonth + 1);
                  } else {
                    setSelectedMonth(1);
                  }
                }}
              />
            </div>
          </div>
          <div className="selection">
            <ul
              className={`
          ${
            stage === 'DAY'
              ? 'day-list'
              : stage === 'MONTH'
                ? 'month-list'
                : 'year-list'
          } `}
            >
              {stage === 'DAY'
                ? renderDays()
                : stage === 'MONTH'
                  ? renderMonths()
                  : renderYears()}
            </ul>
          </div>
        </div>
      </Drawer>

      <ReactModal
        isOpen={isOpen && !isMobile}
        style={{
          overlay: {
            zIndex: 999,
            background: '#00000066',
          },
        }}
        className="calendar-modal"
        shouldCloseOnEsc
        onAfterClose={() => setIsOpen(false)}
        onRequestClose={() => setIsOpen(false)}
      >
        <div className={`calendar`}>
          <div className="modal-header">
            <span>{props.label}</span>
            <CloseOutlined onClick={() => setIsOpen(false)} />
          </div>
          <div className="head">
            <div className="right-side">
              <div className="month" onClick={() => setStage('MONTH')}>
                {MONTHS[(selectedMonth && selectedMonth - 1) || 1]}
              </div>
              <div className="year" onClick={() => setStage('YEAR')}>
                {selectedYear}
              </div>
              <CaretDownOutlined
                onClick={() =>
                  stage === 'MONTH' ? setStage('YEAR') : setStage('MONTH')
                }
              />
            </div>
            <div className="left-side">
              <RightOutlined
                onClick={() => {
                  if (selectedMonth !== 1) {
                    setSelectedMonth(selectedMonth && selectedMonth - 1);
                  } else {
                    setSelectedMonth(12);
                  }
                }}
              />
              <LeftOutlined
                onClick={() => {
                  if (selectedMonth !== 12) {
                    setSelectedMonth(selectedMonth && selectedMonth + 1);
                  } else {
                    setSelectedMonth(1);
                  }
                }}
              />
            </div>
          </div>
          <div className="selection">
            <ul
              className={`
          ${
            stage === 'DAY'
              ? 'day-list'
              : stage === 'MONTH'
                ? 'month-list'
                : 'year-list'
          } `}
            >
              {stage === 'DAY'
                ? renderDays()
                : stage === 'MONTH'
                  ? renderMonths()
                  : renderYears()}
            </ul>
          </div>
        </div>
      </ReactModal>
    </div>
  );
};
